export default [
    {
        key: 5,
        type: 'archive',
        order: {
            number: '122 352 270 419 000 21',
            date_create: 1560776730599
        },
        view: 'ОПГД',
        state: {
            type: 'success',
            accepted: null,
            check: null
        },
        passengers: 24,
        date_of_application: 1561076730599,
        place_of_supply: {
            street: 'ул Широкая, 12',
            city: 'г Москва'
        }
    }
]